<template>
    <h1>Agrolink seo page</h1>
</template>

<script>
export default {
    name: "Seo",
    data() {
        return {
            metaUrl: '/seo',
        }
    }
}
</script>

<style scoped>

</style>
